(() => {
  const init = () => {
    document.querySelectorAll('[data-lnl-gallery]').forEach((gallery) => {
      if (gallery.dataset.loadingReady) return;
      gallery.dataset.loadingReady = 'true';
      const lead = gallery.querySelector('[data-lnl-gallery-slide] img');
      const release = () => {
        gallery.querySelectorAll('template[data-lnl-gallery-image]').forEach((template) => {
          template.replaceWith(template.content.cloneNode(true));
        });
        lead?.removeEventListener('load', release);
        lead?.removeEventListener('error', release);
        gallery.removeEventListener('pointerdown', release);
        gallery.removeEventListener('keydown', release);
      };
      gallery.addEventListener('pointerdown', release, { once: true, passive: true });
      gallery.addEventListener('keydown', release, { once: true });
      if (!lead || lead.complete) {
        release();
      } else {
        lead.addEventListener('load', release, { once: true });
        lead.addEventListener('error', release, { once: true });
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
